<div class="cx-order-summary container" *ngIf="order$">
  <div class="row justify-content-end">
    <div class="col">
      <gen-order-summary [showInfoDAOrder]="false" [data]="order$"></gen-order-summary>
    </div>
  </div>
</div>
